import React from 'react';
import { motion } from 'framer-motion';
import { LayoutDashboard, Repeat, Target } from 'lucide-react';
export function SolucionSection() {
  const pillars = [{
    icon: <LayoutDashboard className="w-10 h-10 text-brand-orange" data-id="element-195" />,
    title: 'Sistema claro',
    description: 'Sabés exactamente qué hacer cada semana. Sin adivinanzas ni pérdida de tiempo.'
  }, {
    icon: <Repeat className="w-10 h-10 text-brand-orange" data-id="element-196" />,
    title: 'Proceso repetible',
    description: 'No dependés de la inspiración ni del azar. Creás una máquina predecible de clientes.'
  }, {
    icon: <Target className="w-10 h-10 text-brand-orange" data-id="element-197" />,
    title: 'Enfoque en consistencia',
    description: 'Resultados sostenibles a largo plazo, terminando con los picos y caídas de ingresos.'
  }];
  return <section id="el-sistema" className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-gray-50 scroll-mt-20" data-id="element-198">
      <div className="max-w-6xl mx-auto" data-id="element-199">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.3
      }} className="text-center mb-16" data-id="element-200">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-brand-black mb-6" data-id="element-201">
            Un sistema claro para escalar tu servicio
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-202">
            Dejá de probar tácticas sueltas y empezá a ejecutar una estrategia
            probada.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-203">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.25,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-204">
              <div className="bg-brand-orange/10 w-20 h-20 rounded-2xl flex items-center justify-center mb-6" data-id="element-205">
                {pillar.icon}
              </div>
              <h3 className="text-2xl font-heading font-bold text-brand-black mb-4" data-id="element-206">
                {pillar.title}
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed" data-id="element-207">
                {pillar.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.15
      }} className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-208">
          <a href="https://centrocumbre.com/cart/46319925100743:1" className="w-full sm:w-auto bg-brand-black text-white font-bold text-lg px-10 py-4 rounded-xl shadow-lg hover:bg-gray-800 hover:scale-[1.03] transition-all text-center" data-id="element-209">
            Aplicar este sistema ahora
          </a>
          <a href="https://wa.me/5492617508744?text=Hola,%20quiero%20más%20información%20sobre%20el%20método%20VSPP" className="w-full sm:w-auto text-brand-black font-medium hover:text-brand-orange transition-colors text-center underline underline-offset-4" data-id="element-210">
            Resolver mis dudas
          </a>
        </motion.div>
      </div>
    </section>;
}